

























































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Role from "@/models/security/role.model";
import Permission from "@/models/security/permission.model";
import ListaRoles from "@/modules/security/roles/lista.vue";
import RoleService from "@/services/role.service";

import { Utils } from "@/core/Utils";
import RolePermission from "@/models/security/rolePermission.model";
import { PermissionValue } from '@/enums/PermissionValue';
import PermissionAccess from '@/models/security/permissionAccess.model';
import UserService from '@/services/user.service';

@Component({
  name: "lista-permisos"
})
export default class ListaPermisosComponent extends Vue {
  @Prop() public rolSelected!: Role;
  @Prop() public usuarioId!: number;
  usuarioService = new UserService();
  rolService = new RoleService();
  permissionsGrouped: Array<{
    category: string;
    permissions: Array<Permission>;
  }> = [];
  permissions: Array<Permission> = [];
  checkedRows: Array<Permission> = [];
  loadingSave: boolean = false;
  permissionValue: PermissionValue = PermissionValue.INICIO;
  permissionAccess:PermissionAccess | any = {};

  created() {
    this.permissionValue = PermissionValue.ROLES;
    this.permissionAccess = this.usuarioService.getPermissionAccessLevel(this.permissionValue);
    this.getPermissionsGrouped();
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  getPermissionsGrouped() {
    this.rolService.getPermisionGroupedByCategory().then((response: any) => {
      
      this.permissionsGrouped = response;
      this.permissions = this.permissionsGrouped.reduce(
        Utils.selectMany((x: any) => x.permissions),
        []
      );
    });
  }

  saveChanges() {
    var newPermission = this.checkedRows.filter(
      x => !this.rolSelected.permissions.some(y => y.permissionId == x.id)
    );
    var deletePermission = this.rolSelected.permissions.filter(
      x => !this.checkedRows.some(y => y.id == x.permissionId)
    );
    for (let i = 0; i < this.rolSelected.permissions.length; i++) {
      const permission = this.rolSelected.permissions[i];
      var row = this.checkedRows.filter(
        x => x.id == permission.permissionId
      )[0];
      if (row)
        permission.permissionAccessLevel =
          row.permissionAccessLevel + row.permissionAccessLevel;
      else permission.permissionAccessLevel = 0;
    }

    newPermission.forEach(permission => {
      var rolPermission = new RolePermission();
      rolPermission.roleId = this.rolSelected.id;
      rolPermission.permissionId = permission.id;
      rolPermission.permissionAccessLevel =
        permission.permissionAccessLevel + permission.permissionAccessLevel;
      this.rolSelected.permissions.push(rolPermission);
    });

    deletePermission.forEach(permission => {
      this.rolSelected.permissions = this.rolSelected.permissions.map(
        rolPermission => {
          if (rolPermission.permissionId == permission.permissionId) {
            rolPermission.deleted = true;
          }
          return rolPermission;
        }
      );
    });
    this.loadingSave = true;
    this.rolService
      .updateRol(this.rolSelected)
      .then(res => {
        this.$buefy.toast.open({
          message: "Los cambios se han aplicado correctamente!",
          type: "is-success"
        });
        this.$emit("rolUpdate", true);
      })
      .catch(err => {
        this.$buefy.toast.open({
          message: err.message,
          queue: false,
          duration: 4000,
          type: "is-danger",
          position: "is-top-right"
        });
      })
      .finally(() => {
        this.loadingSave = false;
      });
  }

  resetChanges() {
    this.permissions.forEach(x => {
      x.permissionAccessLevel = 0;
    });
    this.checkedRows = this.permissions.filter(x =>
      this.rolSelected.permissions.some(
        y => y.permissionId == x.id && !x.deleted
      )
    );
    for (let i = 0; i < this.checkedRows.length; i++) {
      const row = this.checkedRows[i];
      var permission = this.rolSelected.permissions.filter(
        x => x.permissionId == row.id
      )[0];
      if (permission)
        row.permissionAccessLevel = permission.permissionAccessLevel / 2;
      else row.permissionAccessLevel = 0;
    }
  }

  @Watch("rolSelected")
  onChangeRolSelected(rol: Role) {
    if (rol && rol.permissions) {
      this.permissions.forEach(x => {
        x.permissionAccessLevel = 0;
      });
      this.checkedRows = this.permissions.filter(x =>
        rol.permissions.some(y => y.permissionId == x.id && !x.deleted)
      );
      for (let i = 0; i < this.checkedRows.length; i++) {
        const row = this.checkedRows[i];
        var permission = rol.permissions.filter(
          x => x.permissionId == row.id
        )[0];
        row.permissionAccessLevel = permission.permissionAccessLevel / 2;
      }
    }
  }

  permissionsChange(row: any) {
    if (!this.checkedRows.some(x => x.id == row.id)) return;

    if (!row.permissionAccessLevel) {
      row.permissionAccessLevel = 0.5;
    } else if (row.permissionAccessLevel == 1) {
      row.permissionAccessLevel = 0;
    } else if (row.permissionAccessLevel == 0.5) {
      row.permissionAccessLevel = 1;
    }
  }
}
